/**
 * Creator referral attribution — captures ?ref= codes (30-day window)
 * and exposes the active code for signup / planner / booking calls.
 */
const KEY = 'ucw_ref_v1';
const WINDOW_MS = 30 * 24 * 60 * 60 * 1000;

export const captureRef = () => {
  try {
    const code = new URLSearchParams(window.location.search).get('ref');
    if (!code || !/^[a-z0-9-]{1,40}$/i.test(code)) return;
    localStorage.setItem(KEY, JSON.stringify({ code: code.toLowerCase(), ts: Date.now() }));
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/creators/track`;
    const payload = JSON.stringify({ code: code.toLowerCase() });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));
    } else {
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true }).catch(() => {});
    }
  } catch { /* attribution must never break the page */ }
};

export const getRef = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { code, ts } = JSON.parse(raw);
    if (!code || Date.now() - ts > WINDOW_MS) { localStorage.removeItem(KEY); return null; }
    return code;
  } catch { return null; }
};
